import $ from 'jquery';

export default class {
  constructor(el) {
    const self = this;
    self.$el = $(el);
    self.$underline = $(el).find('.js-menu-underline').first();
    self.$active = $(el).find('.c-menu__item a.is-active').first();
    if(self.$active){
      if(self.$active.is('.c-menu__sub-menu__link')) {
        self.$active = self.$active.closest('.c-menu__item.has-active-child').find('a').first();
      }
      self.$underline.width(self.$active.width());
      if(self.$active.parent() && self.$active.parent().position()){
        self.$underline.css({ left: self.$active.parent().position().left });
      }
    }

    self.$el.find('.c-menu__item a').each( ( index, element ) => {
      $(element).on('mouseenter', () => {
        self.$underline.width($(element).width());
        if($(element).parent() && $(element).parent().position()){
          self.$underline.css({ left: $(element).parent().position().left });
        }
      });
      $(element).on('mouseleave', () => {
       if(self.$active){
          self.$underline.width(self.$active.width());
          if(self.$active.parent() && self.$active.parent().position()){
            self.$underline.css({ left: self.$active.parent().position().left });
          }
        }
      });
    });

  }
}



// WEBPACK FOOTER //
// ./scripts/components/Menu.js